import React, { useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hierarchyFacetKey, hierarchyObjects, listOfAllFacetKeys, supplementaryData } from '../configs';
import { updateDefaultFilters } from '../utils/updateDefaultFilters';
import { useDidUpdateLayoutEffect } from '../../hooks/useDidUpdateLayoutEffect';
import { HierarchyContext } from './hierarchy.context';
const domParser = new DOMParser();
const addKeyToList = (key) => {
    if (!listOfAllFacetKeys.includes(key)) {
        listOfAllFacetKeys.push(key);
    }
};
const addHierarchyKeysToListOfFacets = (objects) => {
    Object.values(objects).forEach(({ facetKey }) => { addKeyToList(facetKey); });
};
export const HierarchyProvider = ({ children }) => {
    const { handle } = useParams();
    const [data, setData] = useState(() => ({
        loading: false,
        objects: hierarchyObjects,
        supRecommendedItemsData: supplementaryData.recommendedItems
    }));
    addHierarchyKeysToListOfFacets(data.objects);
    if (handle !== undefined && data.objects[handle] !== undefined) {
        const obj = data.objects[handle];
        obj.pathToCurrent.forEach((step, i) => {
            addKeyToList(obj.facetKey.replace(/lv\d/, `lv${i + 1}`));
        });
    }
    useLayoutEffect(() => {
        if (handle === undefined || data.objects[handle] === undefined)
            return;
        const { facetKey, facetValue } = data.objects[handle];
        updateDefaultFilters(facetKey, facetValue);
        addKeyToList(facetKey.replace(/\d/, (num) => String(+num + 1)));
        addKeyToList(facetKey.replace(/\d/, (num) => String(+num + 2)));
    }, [handle]);
    useDidUpdateLayoutEffect(() => {
        if (handle === undefined)
            return;
        setData({
            ...data,
            loading: true
        });
        void fetch(`/collections/${handle}?section_id=json_collection-data&key=${hierarchyFacetKey}`)
            .then(async (response) => await response.text())
            .then(html => {
            try {
                const parsedDOM = domParser.parseFromString(html, 'text/html');
                const newData = JSON.parse(parsedDOM.body.querySelector('#objectsJSON').innerHTML);
                addHierarchyKeysToListOfFacets(newData);
                let supRecommendedItemsData;
                const recTemplate = parsedDOM.body.querySelector('#supRecommendedItems');
                if (recTemplate !== null) {
                    supRecommendedItemsData = JSON.parse(recTemplate.innerHTML);
                }
                setData({
                    loading: false,
                    objects: {
                        ...data.objects,
                        ...newData
                    },
                    supRecommendedItemsData
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }, [handle]);
    return (React.createElement(HierarchyContext.Provider, { value: data }, children));
};
